/* eslint-disable object-curly-newline */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { get, findKey, toUpper } from 'lodash';
import withTranslate from 'react-redux-multilingual/lib/withTranslate';
import { requestXrefByVenueXids, requestXidsByLegacySymbol } from 'Actions//xrefActions';
import DailyModChart from './DailyModChart';
import AnalystsConsensus from './AnalystsConsensus';
import TopHoldings from './TopHoldings';
import EtfKeyPrices from './EtfKeyPrices';
import StockKeyPrices from './StockKeyPrices';
import './WcAccountHoldingsDrawer.scss';
import EtfMorningstarRating from './EtfMorningstarRating';
import StockMorningstarRating from './StockMorningstarRating';

const WcAccountHoldingsDrawer = props => {
	const [lastUpdated, setLastUpdated] = useState();
	const { translate, symbol, country: countryRaw, venueXid } = props;
	const country = toUpper(countryRaw) === 'CDN' ? 'CA' : toUpper(countryRaw);
	const dispatch = useDispatch();

	const xref = useSelector(state => {
		const upperSymbol = toUpper(symbol);
		return get(state, `xrefData.data.${venueXid}`)
		|| get(state, `xrefData.data.${findKey(get(state, 'xrefData.data'), data => data.symbol === upperSymbol && data.exchange.countryIso === country)}`)
		|| get(state, `xrefData.byLegacyCompany.${findKey(get(state, 'xrefData.byLegacyCompany'), data => data.symbol === upperSymbol && data.exchange.countryIso === country)}`);
	});
	const classificationName = get(xref, 'classification.name');
	const xids = get(xref, 'xids');

	const getXidsForVenueXid = xid => dispatch(requestXrefByVenueXids([xid]));

	useEffect(() => {
		if (venueXid) {
			getXidsForVenueXid(venueXid);
		} else {
			dispatch({
				...requestXidsByLegacySymbol(symbol, country),
				onSuccess: response => {
					const xid = get(response, 'data.0.xid');
					if (xid) {
						getXidsForVenueXid(xid);
					}
				} });
		}
	}, [symbol, country, venueXid]);

	let disclaimer = '';

	if (lastUpdated) {
		disclaimer += `${translate('asOf')} ${lastUpdated} | `;
	}
	disclaimer += translate('marketDataDelayedBy15');

	return (
		<div className="account-holdings-drawer" style={{ textAlign: 'start' }}>
			<div className="drawer-top-row">
				{/* <DailyChart xids={xids} /> */}
				<DailyModChart xids={xids} setLastUpdated={setLastUpdated} />
				{ classificationName === 'ETF' ? <EtfKeyPrices xids={xids} /> : <StockKeyPrices xids={xids} /> }
				{ classificationName === 'ETF' ? <TopHoldings xids={xids} symbol={symbol} country={country} /> : <AnalystsConsensus xids={xids} symbol={symbol} country={country} /> }
				{ classificationName === 'ETF' ? <EtfMorningstarRating xids={xids} /> : <StockMorningstarRating xids={xids} />}
			</div>
			<div className="drawer-bottom-row">
				{disclaimer}
			</div>
		</div>
	);
};

export default withTranslate(WcAccountHoldingsDrawer);
